import type { PricingTierId } from "@/content/pricing";

const frontendUrl =
  process.env.NEXT_PUBLIC_FRONTEND_URL ?? "https://app.rivetai.com";

/** RivetAI product signup (free account). License purchase happens in-app after sign-in. */
export const getFrontendSignupUrl = () =>
  new URL("/signup", frontendUrl).toString();

export const getFrontendLoginUrl = () =>
  new URL("/login", frontendUrl).toString();

export const getHelpCenterUrl = () => "https://help.rivetai.com";

/** Public system status (Better Stack). */
export const getStatusPageUrl = () => "https://status.rivetai.com";

export const getSiteUrl = () =>
  process.env.NEXT_PUBLIC_SITE_URL ?? "https://rivetai.com";

/** When true, staging/preview builds must not be indexed (robots + meta + empty sitemap). */
export const isSiteNoIndex = (): boolean => {
  const value = process.env.NEXT_PUBLIC_NOINDEX?.trim().toLowerCase();
  return value === "1" || value === "true" || value === "yes";
};

export const getEnterpriseContactHref = () => "/contact?intent=enterprise";

export const getContactHref = (
  intent?: "enterprise" | "security" | "general",
) => (intent ? `/contact?intent=${intent}` : "/contact");

export const PRICING_COMPARISON_SECTION_ID = "compare-licenses";

export const getPricingComparisonHref = () =>
  `/pricing#${PRICING_COMPARISON_SECTION_ID}`;

export const getPricingTierCtaHref = (tierId: PricingTierId): string => {
  if (tierId === "enterprise") {
    return getEnterpriseContactHref();
  }

  return getFrontendSignupUrl();
};
